import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { foundItems } from "../../../features/LostFound/dummy/fountItems";

// Initial state
const initialState = {
  brandCd: null,
  keyword: null,
  startDate: null,
  endDate: false,
  loaded: null,
  data: null,
  list: null,
};

// Slice
const lostFoundSlice = createSlice({
  name: "lostFound",
  initialState,
  reducers: {
    initLostFound(state) {
      return {
        ...state,
        brandCd: null,
        keyword: null,
        startDate: null,
        endDate: false,
        loaded: null,
        data: null,
        list: null,
      };
    },
    findItems(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setItems(state, action) {
      const { list } = action.payload;
      return {
        ...state,
        list,
      };
    },
  },
});

export const {
  initLostFound,
  findItems,
  fetchDataSuccess,
  fetchDataFailure,
  setItems,
} = lostFoundSlice.actions;

export default lostFoundSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
    // const response = foundItems;
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { result_code, result_data } = response.data;
      if (result_code === "20000") {
        yield put(setItems({ list: result_data.filter(item => !item.out_date) }));
        // yield put(setItems({ list: [] }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* lostFoundSaga() {
  yield takeLatest(findItems.type, fetchDataSaga);
}
